import { Directive, ElementRef, HostListener, Input, output } from '@angular/core';


@Directive({
    selector: 'input[appNumbersOnly]',
    standalone: true
})
export class NumberDirective {

  readonly valueChange = output();
  constructor(private _el: ElementRef) { }

  @HostListener('input', ['$event']) onInputChange(event) {
    const initalValue = this._el.nativeElement.value;
    const newValue = initalValue.replace(/[^0-9]*/g, '');
    this._el.nativeElement.value = newValue;
    this.valueChange.emit(newValue);
    if (initalValue !== this._el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
